import AlreadyInAGroupValidationResult from "./AlreadyInAGroupValidationResult.js";
import CategoryWithAbsentChildValidationResult from "./CategoryWithAbsentChildValidationResult.js";
import DefaultValidationResult from "./DefaultValidationResult.js";
import DuplicateAccountValidationResult from "./DuplicateAccountValidationResult.js";
import DuplicateGroupIdValidationResult from "./DuplicateGroupIdValidationResult.js";
import EmptyKnownGroupValidationResult from "./EmptyKnownGroupValidationResult.js";
import GapFoundValidationResult from "./GapFoundValidationResult.js";
import MissingKeyValidationResult from "./MissingKeyValidationResult.js";
import ModelFactory from "../../ModelFactory.js";
import MustContainsValidationResult from "./MustContainsValidationResult.js";
import OverlappingIntervalsValidationResult from "./OverlappingIntervalsValidationResult.js";
import OverlappingIntervalsWithAccountsValidationResult from "./OverlappingIntervalsWithAccountsValidationResult.js";

/**
 * This factory can materialize chart of accounts validation results.
 */
class ChartOfAccountsValidationResultFactory extends ModelFactory {
	allClasses() {
		return [
			AlreadyInAGroupValidationResult,
			CategoryWithAbsentChildValidationResult,
			DefaultValidationResult,
			DuplicateAccountValidationResult,
			DuplicateGroupIdValidationResult,
			EmptyKnownGroupValidationResult,
			GapFoundValidationResult,
			MissingKeyValidationResult,
			MustContainsValidationResult,
			OverlappingIntervalsValidationResult,
			OverlappingIntervalsWithAccountsValidationResult,
		];
	}

	_findClassFromType(type) {
		const klass = super._findClassFromType(type);

		return klass || DefaultValidationResult;
	}
}

const chartOfAccountsValidationResultFactory =
	new ChartOfAccountsValidationResultFactory();

export default chartOfAccountsValidationResultFactory;
